import { Buffer } from "buffer";
import React from "react";
import ReactDOM from "react-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import { I18nextProvider } from "react-i18next";
import * as serviceworker from './serviceWorker';
import { i18n } from "./translate/i18n";
import App from "./App";

window.Buffer = Buffer;

ReactDOM.render(
	<CssBaseline>
		<I18nextProvider i18n={i18n}>
			<App />
		</I18nextProvider>
	</CssBaseline>,
	document.getElementById("root"),
	() => {
		if (typeof window.finishProgress === "function") {
			window.finishProgress();
		}
	}
);

// serviceworker.register(); // DESACTIVADO - Va directo al login
